import { UserGroup } from '@nkr/enums/user-group';
import { PORTAL_OPO_STORAGE_KEY } from '@nkr/store/application/actions';
import { IPortalOpo } from '@nkr/store/application/state';
import { useAppHookContext } from '@nkr/utils/rest-api';

interface IRetVal {
    opoId: number,
    opoName: string,
    isAdminView: boolean,
    isAdmin: boolean
}

const readStoredOpo = (): IPortalOpo | null => {
    try {
        const stored = sessionStorage.getItem(PORTAL_OPO_STORAGE_KEY);
        return stored ? JSON.parse(stored) : null;
    } catch {
        return null;
    }
};

const usePortalOpo = (): IRetVal => {
    const { app } = useAppHookContext();

    const isAdmin = app.user != null && app.user.groupId == UserGroup.Admin;
    const selectedOpo = isAdmin ? (app.opo || readStoredOpo()) : null;

    if (selectedOpo) {
        return { opoId: selectedOpo.id, opoName: selectedOpo.name, isAdminView: true, isAdmin };
    }

    return { opoId: app.user.opoId, opoName: app.user.opoName, isAdminView: false, isAdmin };
}

export default usePortalOpo;
